module.exports = __webpack_public_path__ + "static/media/alcohol_drug_issues.81f4d5de.jpg";